<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-upload
        ref="uploadRef"
        class="upload-demo"
        :action="uploadUrl"
        :headers="uploadHeader"
        :data="form"
        :multiple="false"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        :limit="1"
        :on-exceed="onExceed"
        :on-success="onSuccessUpload"
        :on-error="onErrorUpload"
      >
        <template #trigger>
          <el-button style="width: 100%" type="primary">
            Moderatorlarni Excel orqali kiritish
          </el-button>
        </template>
      </el-upload>

      <el-button type="success" @click="downloadFile"
        ><img
          src="@/assets/images/icons/download.svg"
          alt=""
          style="margin-right: 5px"
        />
        Moderatorlar listini yuklab olish
      </el-button>
      <el-select
        v-model="selectedRegion"
        @change="getRegions"
        :loading="regionsLoading"
      >
        <el-option
          v-for="region in regions"
          :key="region.id"
          :value="region.id"
          :label="region.title"
        />
      </el-select>

      <el-button
        class="custom-btn"
        @click="() => this.$router.push({ name: 'ModeratorAdd' })"
        type="primary"
        >Qo'shish</el-button
      >
    </div>
    <el-table :data="moderators" border height="calc(100vh - 210px)">
      <el-table-column type="index" />
      <el-table-column prop="image_id" label="Rasm" min-width="50">
         <template v-slot="scope">
          <img :src="baseUrl + scope.row.image_id" v-if="scope.row.image_id" alt="moderator-img" class="moderator-img">
          <img src="@/assets/images/user-avatar.png" v-else alt="user avatar" class="moderator-img">
        </template>
      </el-table-column>
      <el-table-column prop="fullname" label="Ismi Sharifi" min-width="250" />
      <el-table-column
        prop="district_title"
        label="Tuman/Shahar"
        min-width="150"
      />
      <el-table-column
        prop="last_login_date"
        label="So'nggi kirish vaqti"
        min-width="150"
      >
        <template v-slot="scope">
          {{ scope.row.last_login_date && $moment(scope.row.last_login_date).format("DD-MM-YYYY / HH:MM") }}
        </template>
      </el-table-column>
      <el-table-column prop="pinfl" label="Pinfl" min-width="150" />
      <el-table-column width="200" label="Tahrirlash/O'chirish">
        <template #default="scope">
          <el-button
            size="small"
            @click="onEditModerator(scope.row.id)"
            type="primary"
            >Tahrirlash</el-button
          >
          <el-button
            size="small"
            @click="onDeleteModerator(scope.row.id)"
            type="danger"
            >O'chirish</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Moderatorlar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "ModeratorsList",
  data() {
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/moderators/sync-excel`,
      uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
      form: {
        board_id: null,
      },
      baseUrl: process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/",
      loading: false,
      regionsLoading: false,
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      regions: [],
      moderators: [],
      selectedRegion: null,
    };
  },
  methods: {
    onSuccessUpload() {
      console.log("success upload");
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
      this.getModeratorsList();
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({ name: "Auth" });
      }
      ElNotification.error({
        message:
          JSON.parse(error?.message)?.message ||
          "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },
    downloadFile() {
      this.loading = true;
      this.$http
        .get(`api/v1/users/managers/excel`, {
          responseType: "blob",
        })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const header = res.headers.get("Content-Disposition");
          const parts = header.split(";");
          let fileName = parts[1].split("=")[1];
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message:
              response.data.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onEditModerator(id) {
      this.$router.push({ name: "ModeratorEdit", params: { id } });
    },
    onDeleteModerator(id) {
      ElMessageBox.confirm("Moderatorni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`/api/v1/managers/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Moderator o'chirildi",
              });
              this.getModeratorsList();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions;
          this.getModeratorsList();
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },

    getModeratorsList() {
      this.loading = true;
      this.$http
        .get("/api/v1/managers", {
          params: {
            region_id: this.selectedRegion,
            role: "moderator",
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.moderators = data.users;
          this.totalCount = data.count;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    indexMethod(index) {
      return index + (this.currentPage - 1) * this.limit + 1;
    },
    handleCurrentChange() {
      this.$router.replace({
        query: { ...this.$route.query, page: this.currentPage },
      });
      this.getModeratorsList();
    },
    handleSizeChange() {
      this.$router.replace({
        query: { ...this.$route.query, size: this.limit, page: 1 },
      });
      this.currentPage = 1;
      this.getModeratorsList();
    },
  },
  mounted() {
    this.getRegions();
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
  },
};
</script>

<style scoped>
.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
.moderator-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
